import styled, { css } from 'styled-components'

export const Arrow = styled.div`
  position: absolute;
  ${({
    theme: {
      indents: { baseIndentXs },
      arrows: { faqArrowSizeMd },
    },
  }) => css`
    left: calc(${baseIndentXs} - ${faqArrowSizeMd});
  `};
  width: 0;
  height: 0;
  border-style: solid;
  border-width: ${p => p.theme.arrows.faqArrowSizeMd}
    ${p => p.theme.arrows.faqArrowSizeMd} ${p => p.theme.arrows.faqArrowSizeMd}
    0;
  border-color: transparent
    ${p =>
      p.colorTheme === 'dark'
        ? p.theme.colors.mineShaft
        : p.theme.colors.pictonBlue}
    transparent transparent;
  transition: top ${p => p.theme.animation.timeBtns}
    ${p => p.theme.animation.cubicBezier};
`
